import moment from 'moment';
import {
    HOLIDAYLIST_PAGE,
    HOLIDAYLIST_SEARCH,    
    HOLIDAYLIST_YEAR
} from '../actions/holidaylistactions';

const state = {
    search: '',
    page: 0,    
    year: moment().year(),
};

const getters = {
    page: state => state.page,
    search: state => state.search,        
    year: state => state.year
};

const actions = {
    [HOLIDAYLIST_SEARCH]: ({ commit }, search) => {
        commit(HOLIDAYLIST_SEARCH, search);
    },
    [HOLIDAYLIST_PAGE]: ({ commit }, page) => {
        commit(HOLIDAYLIST_PAGE, page);
    },    
    [HOLIDAYLIST_YEAR]: ({ commit }, year) => {
        commit(HOLIDAYLIST_YEAR, year);
    },
};

const mutations = {
    [HOLIDAYLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [HOLIDAYLIST_PAGE]: (state, page) => {
        state.page = page;
    },    
    [HOLIDAYLIST_YEAR]: (state, year) => {
        state.page = 0;
        state.year = year;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};